import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { apiMethods, apiEndPoints, IncomeSlipsFormsId, common, tSlipType } from '@constants/index';
import { IApiResponse } from '@core/models/index';

@Injectable()
export class ProvincialsService {
  constructor(private readonly http: ApiService) { }

  public submitProvincialDetails(postData): Observable<IApiResponse> {
    const apiEndPoint = `${apiEndPoints.itr}${apiEndPoints.provincialProfile}`;
    return this.http.invoke({
      method: postData.id ? apiMethods.get : apiMethods.post,
      path: postData.id ? `${apiEndPoint}/${postData.itr}` : `${apiEndPoint}`,
      body: postData,
    });
  }

  public fetchProvincialDetails(itrId): Observable<IApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.provincialProfile}/${itrId}`
    });
  }

  public fetchListTSlips(slipType, provincialId): Observable<IApiResponse> {
    const apiEndPoint = slipType === tSlipType.t101Slip ? `${apiEndPoints.itr}${apiEndPoints.t101Slip}` : `${apiEndPoints.itr}${apiEndPoints.t5013Slip}`;
    return this.http.invoke({
      method: apiMethods.get,
      path: apiEndPoint,
      query: { limit: common.defaultPageLimit, provincial_profile: provincialId }
    });
  }

  public getCaiSummary(itrId): Observable<IApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.climateIncentive}/${itrId}`
    });
  }

  public getTaxSummary(itrId): Observable<IApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.taxSummary}/${itrId}`,
    });
  }

  public getReviewTaxSummary(itrId): Observable<IApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.reviewTaxSummary}/${itrId}`
    });
  }
  public getItrDetail(itrId): Observable<IApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}/${itrId}`
    });
  }
  public downloadItr(itrId, isDownloadVal): Observable<IApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.download}/${itrId}`,
      query: { is_download: isDownloadVal }
    });
  }
  public emailItr(itrId): Observable<IApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.emailItr}`,
      query: { itr: itrId }
    });
  }

  public fileTaxReturnComplete(itrId, payload): Observable<any> {
    return this.http.invoke({
      method: apiMethods.patch,
      path: `${apiEndPoints.itr}${apiEndPoints.fileReturnCompleted}/${+itrId}`,
      body: payload
    });
  }

  public getFilingTermConditions(): Observable<IApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.termsAndConditions}`
    });
  }
}
